"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BitPayIcon = props => /*#__PURE__*/_react.default.createElement(_SvgIcon.default, props, /*#__PURE__*/_react.default.createElement("g", {
  transform: "matrix(1 0 0 1 178 212)"
}, /*#__PURE__*/_react.default.createElement("path", {
  style: {
    stroke: 'rgb(0,0,0)',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeLinecap: 'round',
    strokeDashoffset: 0,
    strokeLinejoin: 'round',
    strokeMiterlimit: 10,
    fill: 'none',
    fillRule: 'nonzero',
    opacity: 1
  },
  transform: " translate(-178, -212)",
  d: "M 177.999 212 L 178.001 212",
  strokeLinecap: "round"
})), /*#__PURE__*/_react.default.createElement("g", {
  transform: "matrix(0.03 0 0 0.03 7.25 10.65)"
}, /*#__PURE__*/_react.default.createElement("path", {
  style: {
    stroke: 'none',
    strokeWidth: 1,
    strokeDasharray: 'none',
    strokeLinecap: 'butt',
    strokeDashoffset: 0,
    strokeLinejoin: 'miter',
    strokeMiterlimit: 4,
    fillRule: 'evenodd',
    opacity: 1
  },
  transform: " translate(-600, -597.65)",
  d: "m 556.178527 841.694737 c 21.242499 0 40.945686 -4.533081 59.133244 -15.864604 c 18.211239 -9.821283 34.883167 -23.418167 48.523835 -40.793011 c 13.640668 -16.619725 24.273758 -36.25993 31.851907 -57.410376 c 7.578149 -21.907926 11.367224 -43.815852 11.367224 -67.231658 c 0 -28.706368 -4.54689 -50.614294 -14.398483 -67.234018 c -9.875276 -16.619725 -29.578463 -23.415807 -55.344169 -23.415807 c -8.335964 0 -16.69561 0.752761 -30.336278 3.775601 c -13.640668 3.020481 -25.007892 9.821283 -36.375115 18.885085 l -58.375429 246.265947 c 18.187558 3.022841 37.13293 3.022841 43.953264 3.022841 z m 117.591677 -384.693584 c 28.765889 0 53.726265 5.293573 74.928403 15.878358 c 21.178502 9.83126 37.818753 23.441956 52.189879 41.590339 c 13.638387 17.394857 23.471263 37.810901 30.278638 61.250495 c 6.807376 23.444318 9.832876 48.398049 9.832876 75.619441 c 0 41.590339 -7.56375 80.157128 -23.447627 117.20978 c -15.907512 36.296765 -36.329639 69.567618 -62.802765 96.035486 c -26.496764 27.221392 -57.508141 49.151574 -93.83778 64.274045 c -36.306002 15.88072 -74.904766 23.441956 -116.529031 23.441956 c -5.294625 0 -15.127501 0 -28.742252 -0.755888 c -13.638387 0 -29.522263 -1.511774 -46.162514 -3.779436 c -17.396627 -3.025912 -36.329639 -6.049461 -55.239016 -10.587147 c -19.665751 -4.537686 -37.842389 -11.343035 -55.239015 -19.660157 l 155.88417 -652.588244 l 139.220283 -21.930181 l -55.239016 231.391286 c 12.102001 -5.291212 23.471264 -9.828898 35.573264 -12.098922 c 12.858376 -3.779437 25.716752 -5.291211 39.331503 -5.291211 z",
  strokeLinecap: "round"
})));
var _default = exports.default = BitPayIcon;